'use es6';

import { createTracker } from 'usage-tracker';
export const usageTracker = createTracker({
  standalone: true,
  properties: {
    source: 'wootric-nps'
  }
});